import { render, staticRenderFns } from "./themeDescModal.vue?vue&type=template&id=2300d0bc&scoped=true"
import script from "./themeDescModal.vue?vue&type=script&lang=js"
export * from "./themeDescModal.vue?vue&type=script&lang=js"
import style0 from "./themeDescModal.vue?vue&type=style&index=0&id=2300d0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2300d0bc",
  null
  
)

export default component.exports